/**
 * @name BackupAssignments
 * @description Componente para visualizar y rechazar las asignaciones de backup en configuración de perfil
 * @author Gerardo de León
 */

import React, { Component } from 'react';
import i18n from 'i18next';
import moment from 'moment';
import styled from 'styled-components';
import { trackPromise } from 'react-promise-tracker';

import { Environment } from '@tycommon/config';
import { DataGrid } from '@tycommon/components';
import { BackupService, ResponseHandlerService, NotificationsService } from '@tycommon/services';
import { Icons, MUI } from '@tycommon/styles';

// Components
import RejectDialog from './components/reject.dialog';

class BackupAssignments extends Component {
  constructor(props) {
    super(props);
    this.userInfo = JSON.parse(localStorage.getItem('ls.infoUsuario')).Empleado;
    this.state = {
      gridConfig: {
        rows: [],
        columns: [
          { id: 'IdBackup', label: i18n.t('IdBackup'), visible: false, filter: null },
          { id: 'IdEmpleado', label: i18n.t('IdEmpleado'), visible: false, filter: null },
          { type: 'complex', id: ['Foto', 'Nombre', 'Puesto'], label: i18n.t('GenericMessages.employee'), visible: true, filter: null, minWidth: 250 },
          { id: 'FechaRegistro', label: i18n.t('GenericMessages.registrationDate'), visible: true, filter: 'ShortDateFilter' },
          { id: 'FechaInicio', label: i18n.t('GenericMessages.startDate'), visible: true, filter: 'ShortDateFilter' },
          { id: 'FechaFin', label: i18n.t('GenericMessages.endDate'), visible: true, filter: 'ShortDateFilter' },
          { id: 'Comentario', label: i18n.t('GenericMessages.comment'), visible: true, filter: null },
          { id: 'Estatus', label: i18n.t('GenericMessages.status'), visible: true, filter: null, sort: true },
          //{ type: 'cell-action' id: 'Rechazar', label: 'Rechazar', visible: true, filter: null }
        ],
        canAdd: false,
        canEdit: false,
        canDelete: true,
        canSelect: true,
      },
      showRejectDialog: {
        data: {},
        open: false
      }
    };
  }

  componentDidMount() {
    this.getBackupAssigments();
  }

  getBackupAssigments = () => {
    const { gridConfig } = this.state;

    trackPromise(
      BackupService.getAssigments()
        .then((response) => {
          // response.map((item) => {
          //   item.Rechazar = <MUI.ButtonCTA
          //     type="button"
          //     color="secondary"
          //     //disabled={!formikProps.isValid || formikProps.isSubmitting}
          //     onClick={(item) => this.showBackupDialog(item)}
          //   >
          //     {i18n.t('DialogConfirm.cancel')}
          //   </MUI.ButtonCTA>;
          // })
          // NOTA: Se resta un día a la Fecha Fin para mostrarla de forma correcta.
          response.map((item) => {
            item.FechaFin = moment(item.FechaFin).subtract(1, 'days');
          });
          gridConfig.rows = response;
          this.setState((prevState) => ({ gridConfig: { ...prevState.gridConfig, gridConfig } }));
        })
        .catch((error) => {
          ResponseHandlerService.error(error);
          gridConfig.rows = [];
          this.setState((prevState) => ({ gridConfig: { ...prevState.gridConfig, gridConfig } }));
        }),
      'loading-tab-backup-assignment'
    );
  }

  /* 
    Estatus 1 - Confirmado
    Estatus 2 - Rechazado
    Estatus 3 - Cancelado
    Estatus 1 - Finalizado

    [CANCELAR] No se puede cancelar si esta corriendo el periodio de backup o ya termino.
    [RECHAZAR] No se puede rechazar si el periodo de backup empieza mañana o ya termino.
  */

  rejectBackup = (values, backup, setSubmitting) => {
    //console.log('rjeect', values, backup);
    //console.log('UserInfo', this.userInfo)
    let request = {
      IdBackup: values.id,
      Comentario: values.comment,
      Estatus: 2
    };

    // Notificación - <colaborador> ha rechazado tu solicitud como backup
    let notificationToSend = {
      IdAmbiente: Environment.getCurrent().environmentId,
      URL: '#/configuraperfil',
      IdTipoNotificacion: 130,
      IdEmpleado: backup.IdEmpleado,
      Parametros: JSON.stringify({ Tab: 6 }),
      Propiedades: JSON.stringify({ colaborador: `${this.userInfo.Nombres} ${this.userInfo.Apellidos}` })
    };

    BackupService.put(request)
      .then((response) => {
        setSubmitting(false);
        this.closeDialog('comment');
        this.getBackupAssigments();
        NotificationsService.post(notificationToSend);
        ResponseHandlerService.success(response);
      })
      .catch((error) => {
        setSubmitting(false);
        ResponseHandlerService.error(error);
      });
  }

  showBackupDialog = (item) => {
    //console.log('showBackupDialog', item);
    let data = item ? { ...item[0] } : {};
    this.setState({ showRejectDialog: { data, open: true } });
  };

  closeDialog = (dialog) => {
    if (dialog === 'comment') {
      this.setState({ showRejectDialog: { data: {}, open: false } });
    }
  }

  render() {
    const { gridConfig } = this.state;

    return (
      <>
        <ContentWrapper>
          <MUI.Box padding="8px">
            {/* <MUI.ButtonCTA
              type="button"
              color="secondary"
            //disabled={!formikProps.isValid || formikProps.isSubmitting}
            //onClick={formikProps.handleSubmit}
            >
              {i18n.t('DialogConfirm.cancel')}
            </MUI.ButtonCTA> */}

            <DataGrid
              // ref={this.dataGridRef} 
              columns={gridConfig.columns}
              rows={gridConfig.rows}
              canAdd={gridConfig.canAdd}
              canEdit={gridConfig.canEdit}
              canDelete={gridConfig.canDelete}
              canSelect={gridConfig.canSelect}
              canSelectMultiple={false}
              canSort={true}
              isPaginated={true}
              // action={{
              //   component: '',
              //   label: '',
              //   color: '',
              //   disabled: '',
              //   action: ''
              // }}
              onDelete={(item) => this.showBackupDialog(item)}
            />
          </MUI.Box>
        </ContentWrapper>

        {/* Modal para rechazar backups */}
        {this.state.showRejectDialog.open ? (
          <RejectDialog
            data={this.state.showRejectDialog.data}
            open={this.state.showRejectDialog.open}
            onClose={() => this.closeDialog('comment')}
            onRejectBackup={this.rejectBackup}
          />
        ) : null}
      </>
    );
  }
}

const ContentWrapper = styled.section`
  display: flex;
  flex-direction: column;
  padding: 8px;
  border: 1px solid ${(props) => props.theme.colors.greyLight};
  border-radius: 6px;
  box-shadow: ${(props) => props.theme.shadows.depth1};
`;

export default BackupAssignments;